<template>
    <div
        class="o-searchresult searchresult"
        :class="{'searchresult__no-matches': !hasMatches || !hasStrictResult}"
    >
        <div
            v-if="!hasMatches && isNomatchesShow"
            class="searchresult__text-item"
        >
            <span class="searchresult__text">
                {{ $t('searchresult__no-results') }}
            </span>
        </div>
        <div
            v-else-if="!hasStrictResult && !isLandscape && isNomatchesShow"
            class="searchresult__text-item"
        >
            <span class="searchresult__text-no-matches">
                {{ $t('searchresult__no-matches') }}
                <!--&lt;!&ndash;No matches, you may be looking for it:&ndash;&gt;-->
            </span>
        </div>
        <RecycleScroller
            #default="{ item }"
            :items="items"
            :item-size="itemListSize"
            key-field=""
            class="searchresult__scroller"
        >
            <OWTilePlaceholder v-if="placeholders" />
            <OWItemSearchTile
                v-else-if="t(item, 'type') === 'tenant' || t(item, 'type') === 'service'"
                :item="item"
                @onClick="handleClick"
            />
            <OWItemSearchCategoryTile
                v-else
                :item="item"
                @onClick="handleClick"
            />
        </RecycleScroller>
    </div>
</template>

<script>
import { 
    mapGetters,
    mapState
} from 'vuex';

import OWTilePlaceholder from '../../organisms/o-w-tile-placeholder/o-w-tile-placeholder'
import OWItemSearchTile from '../../organisms/o-w-item-search-tile/o-w-item-search-tile';
import OWItemSearchCategoryTile from '../../organisms/o-w-item-search-category-tile/o-w-item-search-category-tile';

export default {
    name: 'OSearchresult',
    components: {
        OWItemSearchTile,
        OWTilePlaceholder,
        OWItemSearchCategoryTile
    },
    data() {
        return {
            renderItems: 10
        }
    },
    props: {
        items: {
            type: [Array, Number],
            default: () => []
        },
        placeholders: {
            type: Boolean,
            default: false
        },
        hasStrictResult: {
            type: Boolean,
            default: false
        },
        isNomatchesShow: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            't'
        ]),
        hasMatches(){
            return this.items.length || this.placeholders
        },
        itemListSize() {
            return this.isLandscape ? 38 : 67
        }
    },
    methods: {
        handleClick(data) {
            this.$emit('onSearchTileClick', data);
        }
    }
}
</script>

<style lang="scss">
@import "o-searchresult";
</style>
